import { plainToInstance } from 'class-transformer'

import { CommentNotificationParamsType } from '@client/collections/Notification/interface'
import { GET_NOTIFICATION_COMMENT_PAGE } from '@client/collections/Notification/schemas/getNotificationCommentPage'
import { GET_TOTAL_NOTIFICATION_COMMENT } from '@client/collections/Notification/schemas/getTotalNotificationComment'
import { GET_USER_COMMENT_NOTIFICATION } from '@client/collections/Notification/schemas/getUserCommentNotification'
import { CommentNotificationResponse } from '@models/notification/CommentNotificationResponse'
import { gqlApiInstance } from '@client/init'

export function useNotificationAction() {
  async function getCommentNotification(
    params: CommentNotificationParamsType
  ): Promise<CommentNotificationResponse> {
    const { getUserCommentNotification } = await gqlApiInstance.request(
      GET_USER_COMMENT_NOTIFICATION,
      {
        page: params.page,
        limitPerPage: params.limitPerPage,
        commentNotificationType: params.commentNotificationType,
        bookId: params.bookId || undefined,
        bookType: params.bookType || undefined,
      }
    )

    return plainToInstance(
      CommentNotificationResponse,
      getUserCommentNotification
    )
  }

  async function getTotalNotificationComment(): Promise<number> {
    const res = await gqlApiInstance.request(GET_TOTAL_NOTIFICATION_COMMENT)

    return res.getTotalNotificationComment.totalComment
  }

  async function getNotificationCommentPage({
    commentId,
    bookId,
    bookChapterId,
  }: {
    commentId: number
    bookId?: number
    bookChapterId?: number
  }): Promise<number> {
    const res = await gqlApiInstance.request(GET_NOTIFICATION_COMMENT_PAGE, {
      pageSize: 10,
      commentId,
      bookId,
      bookChapterId,
    })

    return res.getNotificationCommentPage.page
  }

  return {
    getCommentNotification,
    getTotalNotificationComment,
    getNotificationCommentPage,
  }
}
